// 📄 components/common/ChannelProgressBar.tsx
// Mini-barra de progreso horizontal reutilizable (cards de canales, etc.)
import React from 'react';

interface ChannelProgressBarProps {
  completed: number;
  total: number;
  height?: number;
}

export default function ChannelProgressBar({ completed, total, height = 4 }: ChannelProgressBarProps) {
  const pct = total > 0 ? Math.round((completed / total) * 100) : 0;
  const barColor = pct === 100 ? '#10b981' : pct > 0 ? '#2563eb' : '#4b5563';

  return (
    <div className="w-full bg-white/10 rounded-full overflow-hidden mt-2" style={{ height: `${height}px` }}>
      <div
        className="h-full rounded-full transition-all duration-300"
        style={{ width: `${pct}%`, backgroundColor: barColor }}
      />
    </div>
  );
}
